const ON_CHANGE_DEBOUNCE_TIMER=300,PUB_SUB_EVENTS={cartUpdate:"cart-update",quantityUpdate:"quantity-update",variantChange:"variant-change",cartError:"cart-error"};
//# sourceMappingURL=/s/files/1/0693/1323/3172/t/38/assets/constants.js.map?v=1751359252
